import { generateClient } from "aws-amplify/api";
const client = generateClient();

export const cancelAPIRequest = (request) => {
  if (request) {
    client.cancel(request, "Cancel Request");
  }
};

export const cancelRestAPIRequest = (request) => {
  if (request && typeof request.cancel === 'function') {
    request.cancel();
  }
};

export const cancelStorageRequest = (request) => {
  if (request?.cancel) {
    request.cancel();
  }
};

export const extractS3Key = (s3Path) => {
  if (!s3Path) return "";
  const parts = s3Path.split("/");
  if (
    (parts[0] === "private" || parts[0] === "protected") &&
    parts.length > 2
  ) {
    return parts.slice(2).join("/");
  }
  if (parts[0] === "public" && parts.length > 1) {
    return parts.slice(1).join("/");
  }
  return s3Path;
};
